document.addEventListener('DOMContentLoaded', function() {
    var uniqueId = sessionStorage.getItem('tab_identifier');
    if (!uniqueId) {
        uniqueId = (Math.random() + 1).toString(36).substring(7);  // Generate a new unique identifier
        sessionStorage.setItem('tab_identifier', uniqueId);
    }

    sendTabIdentifierToServer(uniqueId);
});

document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
        var uniqueId = sessionStorage.getItem('tab_identifier');
        if (uniqueId) {
            sendTabIdentifierToServer(uniqueId);
        }
    }
});

function sendTabIdentifierToServer(uniqueId) {
    axios.post('/api/identify-browsertab', { tab_identifier: uniqueId });
}

